<template>
    <div>
        <header-segmented-survey></header-segmented-survey>
        <div id="container" class="main-container p-0">
            <div id="content" class="main-content justify-content-center mx-0">
                <router-view></router-view>
                <app-modal id="modal-termos-e-condicoes" :show="modalTerms.show" @on-close="modalTerms.reject" size="fullscreen">
                    <template #title>Termos e Condições</template>
                    <template #body>
                        <div class="container">
                            <div class="segmented-survey-terms col-lg-8 m-auto" v-html="modalTerms.terms?.html"></div>
                        </div>
                        <hr class="border">
                        <div class="d-flex justify-content-between gap-2">
                            <app-button
                                variant=""
                                text="Cancelar"
                                icon="xmark"
                                @click="modalTerms.reject"
                            />
                            <app-button
                                variant="success"
                                text="Aceitar Termo de Adesão e Consentimento"
                                icon="check"
                                @click="modalTerms.accept"
                            />
                        </div>
                    </template>
                </app-modal>

                <app-modal id="modal-update-company" size="xl" :show="modalUpdateCompany.show" @on-close="modalUpdateCompany.close">
                    <template #title>Atualizar Informações</template>
                    <template #body>
                        <form @submit.prevent="modalUpdateCompany.save">
                            <segmented-survey-company-form
                                ref="refCompanyForm"
                                v-model="formData"
                                v-model:load-page="modalUpdateCompany.load"
                                :load-btn="modalUpdateCompany.load"
                                :errors="modalUpdateCompany.errors"
                                :is-unique-cnpj="false"
                            />

                            <hr class="border">
                            <div class="d-flex justify-content-between gap-2">
                                <app-button
                                    variant=""
                                    text="Cancelar"
                                    icon="xmark"
                                    @click="modalUpdateCompany.close"
                                />
                                <app-button
                                    variant="success"
                                    text="Salvar"
                                    icon="save"
                                    type="submit"
                                    :load="modalUpdateCompany.load"
                                />
                            </div>
                        </form>
                    </template>
                </app-modal>
                
                <footer></footer>
            </div>
        </div>
    </div>
</template>

<script setup>
    import HeaderSegmentedSurvey from '@/components/layout/header-segmented-survey.vue';
    import AppButton from '@/components/AppButton.vue';
    import AppModal from '@/components/AppModal.vue';
    import { useStore } from 'vuex';
    import { computed, onMounted, reactive, ref, watch } from 'vue';
    import SegmentedSurveyCompanyForm from '@/views/segmented_survey/partials/segmented-survey-company-form.vue';
    
    const store = useStore();
    const company = computed(() => store.state.segmentedSurveyCompany.company);
    const refCompanyForm = ref(null);
    
    const formData = reactive({
        id: null,
        name: null,
        social_name: null,
        contact_name: null,
        email: null,
        phone_number: null,
        cnpj: null,
        size: null,
        cnae_id: null,
        address: {
            state_id: null,
            city_id: null,
            cep: null,
            address: null,
            district: null,
            number: null,
            complement: null
        },

        setFormData(company = null) {
            refCompanyForm.value?.setFormData(company);
        }
    });
    
    const modalTerms = reactive({
        terms: computed(() => store.getters['segmentedSurveyCompany/terms']),
        show: computed(() => store.state.segmentedSurveyCompany.show_modal_terms),
        
        open: () => store.commit('segmentedSurveyCompany/openModalTerms'),
        close: () => store.commit('segmentedSurveyCompany/closeModalTerms'),
        accept() {
            modalTerms.close();
            store.dispatch('segmentedSurveyCompany/acceptTerm');
        },
        reject() {
            modalTerms.close();
            store.dispatch('segmentedSurveyCompany/logout');
        }
    });

    const modalUpdateCompany = reactive({
        show: computed(() => store.state.segmentedSurveyCompany.show_modal_update),
        load: computed(() => store.state.segmentedSurveyCompany.load),
        errors: computed(() => store.state.segmentedSurveyCompany.errors),
        
        open() {
            store.commit('segmentedSurveyCompany/openModalUpdate');
        },
        close() {
            store.commit('segmentedSurveyCompany/closeModalUpdate');
        },
        async save() {
            await store.dispatch('segmentedSurveyCompany/update', formData);
            modalUpdateCompany.close();
        },
    });
    
    const showTerms = async (company) => {
        if (!company?.accepted_terms) {
            await store.dispatch('segmentedSurveyCompany/getTerms');
            store.commit('segmentedSurveyCompany/openModalTerms');
        }
    }
    
    const close = watch(() => company.value, async (company) => {
        await showTerms(company);
        close();
    });
    
    onMounted(() => {
        if (company.value) {
            showTerms(company.value);
        }
    });
    
    watch(() => store.state.segmentedSurveyCompany.show_modal_update, (state) => {
        if(!!state) {
            formData.setFormData(company.value);
        }else {
            formData.setFormData();
        }
    });
</script>

<style>
    .segmented-survey-terms section {
        margin-bottom: 1rem;
    }

    .segmented-survey-terms h2 {
        font-size: 1.25rem;
        margin-top: 2rem;
        margin-bottom: 1rem;
        line-height: 1.5;
    }

    .segmented-survey-terms h3 {
        font-size: 1.1rem;
        margin-top: 1.5rem;
        margin-bottom: 0.75rem;
        line-height: 1.5;
    }

    .segmented-survey-terms p,
    .segmented-survey-terms li {
        font-size: 14px;
        color: #3b3f5c !important;
        line-height: 1.7;
        margin-bottom: 1rem;
    }

</style>
